<template lang="pug">
  .b-accordion(:class="{ opened: openedInner }")
    ._header(@click="toggleAccordion")
      ._title {{ title }}
        slot(name="header")
      ._line
      Icon._icon(name="round-app" pointer)
    ._content
      slot
</template>

<script>
export default {
  name: 'BaseAccordion',
  model: { prop: 'opened', event: 'toggle' },
  props: {
    title: String,
    opened: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      openedInner: true,
    };
  },
  watch: {
    opened: {
      immediate: true,
      handler(val) { this.openedInner = val; },
    },
  },
  methods: {
    toggleAccordion() {
      this.openedInner = !this.openedInner;
      this.$emit('toggle', this.openedInner);
    },
  },
};
</script>

<style scoped lang="scss">
.accordion {
  &__header {
    display: grid;
    align-items: center;
    grid-template-columns: auto 1fr min-content;
    gap: 6px;
    padding-bottom: 26px;
    cursor: pointer;
  }

  &__title {
    color: var(--middle-gray, #788CA1);
    font-family: Geometria, sans-serif;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 184.615% */
    padding-right: 8px;
  }

  &__icon {
    rotate: 180deg;

    &:hover {}
  }

  .opened &__icon {
    rotate: 0deg;
  }

  &__line {
    height: 1px;
    background-color: rgba(209, 217, 240, 1);
  }

  &__content {
    display: none;
  }

  &.opened &__content {
    display: block;
  }
}
</style>
